import type { IconProps } from "@mui/material"
import { Icon } from "@mui/material"

export default function ConversationCardEmailIcon(props?: IconProps) {
  return (
    <Icon {...props}>
      <svg
        key={"email"}
        id="Group_6431"
        data-name="Group 6431"
        xmlns="http://www.w3.org/2000/svg"
        width={(props?.sx as { width?: number })?.width || "15"}
        height={(props?.sx as { height?: number })?.height || "15"}
        viewBox="0 0 15 15"
      >
        <rect
          id="Rectangle_1173"
          data-name="Rectangle 1173"
          width="16"
          height="16"
          rx="2"
          fill="#fff"
        />
        <path
          id="email"
          d="M10.171.875a1.109,1.109,0,0,1,.808.326A1.072,1.072,0,0,1,11.311,2V8.664a1.072,1.072,0,0,1-.331.795,1.107,1.107,0,0,1-.808.325H1.139a1.109,1.109,0,0,1-.808-.326A1.072,1.072,0,0,1,0,8.663V2A1.072,1.072,0,0,1,.331,1.2,1.109,1.109,0,0,1,1.139.875Zm0,2.24V2L5.642,4.782,1.139,2v1.12l4.5,2.761Z"
          transform="translate(1.845 2.171)"
          fill="#58a3ff"
        />
      </svg>
    </Icon>
  )
}
